<template>
    <div class="global-messenger">
        <!-- Toast Notifications -->
        <div id="noty_layout__topRight" role="alert" aria-live="polite" class="noty_layout">
            <transition-group name="toast" tag="div">
                <div
                    v-for="toast in toasts"
                    :key="toast.id"
                    :class="['noty_bar', 'noty_type__' + toast.level, 'noty_theme__bootstrap-v4', 'noty_has_progressbar']"
                    @click="removeToast(toast.id)"
                >
                    <div class="noty_body">{{ toast.message }}</div>
                </div>
            </transition-group>
        </div>

        <!-- Loading Overlay -->
        <div
            v-if="loading"
            class="position-fixed fade-in"
            style="top: 0px; left: 0px; bottom: 0px; right: 0px; z-index: 1051 !important;"
        >
            <div
                class="position-absolute bg-white"
                style="top: 0px; left: 0px; bottom: 0px; right: 0px; opacity: 0.85; backdrop-filter: blur(2px);"
            ></div>
            <div class="position-absolute" style="top: 50%; left: 50%; transform: translateX(-50%) translateY(-50%);">
                <div class="messenger-loader" style="height: 50px; width: 50px;">
                    <svg version="1.1" class="loader-center" viewBox="0 0 180 180" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M78.1,164.1l8,-15.9c-27.1,-1.8 -49,-22.1 -53.4,-48.4l-16.5,-8.4l-15.3,7.8c4.2,43.8 40.4,78.6 85,80.6l-7.8,-15.7Zm23.9,-147.7l-7.9,15.9c27,1.8 48.9,22.1 53.3,48.4l16.5,8.3l15.4,-7.7c-4.2,-43.8 -40.4,-78.7 -85,-80.7l7.7,15.8Zm61.9,85.8l-15.9,-8c-1.8,27.1 -22.1,49 -48.4,53.4l-8.3,16.5l7.7,15.3c43.8,-4.1 78.7,-40.4 80.7,-85l-15.8,7.8Zm-163.4,-16.1c2,-44.6 36.8,-80.9 80.8,-85.1l7.8,15.4l-8.4,16.5c-26.3,4.4 -46.8,26.3 -48.6,53.4l-15.9,-8l-15.7,7.8Z"
                            fill="#CE0F2D"
                            stroke="none"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GlobalMessenger',

    data() {
        return {
            loading: false,
            toasts: [],
            timeout: 3000,
            toastIdCounter: 0,
        };
    },

    created() {
        // Listen for Vue Bus events
        Bus.$on('toast', this.addToast);
        Bus.$on('loading', this.setLoading);

        // Bridge Livewire events to Vue
        this.setupLivewireBridge();
    },

    beforeDestroy() {
        Bus.$off('toast', this.addToast);
        Bus.$off('loading', this.setLoading);
    },

    methods: {
        setupLivewireBridge() {
            // Wait for Livewire to be available
            if (typeof window.Livewire !== 'undefined') {
                this.registerLivewireListeners();
            } else {
                document.addEventListener('livewire:init', () => {
                    this.registerLivewireListeners();
                });
            }
        },

        registerLivewireListeners() {
            // Listen for Livewire 'toast' events and forward to Vue
            window.Livewire.on('toast', (data) => {
                // Handle both array format and direct parameters
                if (Array.isArray(data)) {
                    this.addToast(data[0], data[1] || 'success');
                } else if (typeof data === 'object') {
                    this.addToast(data.message || data, data.level || 'success');
                } else {
                    this.addToast(data, 'success');
                }
            });

            // Listen for Livewire 'loading' events and forward to Vue
            window.Livewire.on('loading', (data) => {
                if (Array.isArray(data)) {
                    this.setLoading(data[0]);
                } else {
                    this.setLoading(data);
                }
            });
        },

        addToast(message, level = 'success') {
            const id = `toast-${++this.toastIdCounter}-${Date.now()}`;

            this.toasts.push({
                id,
                message,
                level: level || 'success',
                createdAt: Date.now(),
            });

            // Auto-remove after timeout
            setTimeout(() => {
                this.removeToast(id);
            }, this.timeout);
        },

        removeToast(id) {
            const index = this.toasts.findIndex((t) => t.id === id);
            if (index > -1) {
                this.toasts.splice(index, 1);
            }
        },

        setLoading(isLoading) {
            this.loading = Boolean(isLoading);
        },
    },
};
</script>

<style scoped>
.toast-enter-active {
    transition: all 0.2s ease-out;
}

.toast-leave-active {
    transition: all 0.2s ease-in;
}

.toast-enter {
    transform: translateX(20px);
    opacity: 0;
}

.toast-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}

.loader-center {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>